import {Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { OBPPQuickPayService } from 'src/app/services/quick-pay/quick-pay.service';
import { QuickPaySecurityAudit } from 'src/app/models/new-user-registration.model';
import { Router } from '@angular/router';
import { OBPPModalDialogComponent } from 'src/app/components/error-component/modal-dialog/modal-dialog.component';
import { OBPPLoginService } from 'src/app/services/login-page/login-page.service';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import {debounceTime, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'modal-quick-pay-invoice',
  templateUrl: './modal-quick-pay-invoice.component.html',
  styleUrls: ['./modal-quick-pay-invoice.component.scss'],
})
export class OBPPQuickPayInvoiceComponent implements OnInit,OnDestroy {
  @Input() my_modal_title: string = '';
  @Input() my_modal_content: string = '';
  @Input() firstButtonLabel: string = '';
  @Input() secondButtonLabel: string = '';
  @Input() modalType: string = '';
  @Input() accountNumber: any = [];
  @Input() invoiceNumber: string[] = [];
  @Input() invoiceCurrency: string[] = [];
  @Output() successAction = new EventEmitter();
  @Output() cancelAction = new EventEmitter();

  isDuplicatePay: boolean = false;
  isFormValid: boolean = false;
  isLoading: boolean = false;
  secAuditData?: QuickPaySecurityAudit | any;

  QuickPayInvoiceForm!: FormGroup;
  userEmailID: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private obppQuickPayService: OBPPQuickPayService,
    private route: Router,
    private modalService: NgbModal,
    private obppAuthService: OBPPLoginService,
    private dataSharingService: DataSharingService,
  ) {
    this.QuickPayInvoiceForm = this.fb.group({
      accountNumber: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(12)]],
      invoiceNumber: ['', [Validators.required, Validators.maxLength(15)]],
      postalCode: ['', [Validators.required, Validators.maxLength(11)]]
    });
  }
  ngOnInit(): void {
   this.subscribeToFormChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  subscribeToFormChanges(): void {
    this.QuickPayInvoiceForm.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkDuplicateInvoice();
        this.isFormValid = !(
          this.isDuplicatePay ||
          this.QuickPayInvoiceForm.get('invoiceNumber')?.invalid ||
          this.QuickPayInvoiceForm.get('postalCode')?.invalid ||
          this.QuickPayInvoiceForm.get('accountNumber')?.invalid
        );
      });
  }

  cancelActionFunc() {
    this.userEmailID = '';
    this.cancelAction.emit('');
    this.activeModal.close('Cancel');
  }

  checkDuplicateInvoice() {
    this.isDuplicatePay = this.invoiceNumber.includes(this.QuickPayInvoiceForm.get('invoiceNumber')?.value?.trim());
  }

  getQuickPayData(accountNumber: string, invoiceNumber: string, postalCode:string) {
    this.dataSharingService.IsLoadingEnabled.next(true);
    this.secAuditData = {
      accountNumber,
      attemptEntryPage: 'QuickPay',
      invoiceNumber,
      postalCode,
      status: false,
      userEmailId: null,
    };
    const tit = 'QUICK_PAY_TEXT';
    const errMsg = 'QUICK_PAY_ERROR';
    this.obppQuickPayService
      .getAccountInfoByDetails(accountNumber, invoiceNumber, postalCode)
      .subscribe({
        next: (res) => {
          this.dataSharingService.IsLoadingEnabled.next(false);
          if (res.serviceResponse.type == 'success') {
            this.secAuditData.status = true;
            this.obppQuickPayService.quickPayData = res.serviceResponse;
            // this.obppQuickPayService.selectedInvoice = inv;

            // res.serviceResponse.object.obppInvoices[].invoiceCurrency not equal this.invoiceCurrency
            // then isCurrencyMismatch should be true
            const isCurrencyMismatch: boolean = res.serviceResponse.object.obppInvoices.some(
              (inv: any):boolean => inv.invoiceCurrency !== this.invoiceCurrency?.[0]
            );
            isCurrencyMismatch && console.error("Currency mismatch occured");

            if (res.serviceResponse.object.obppInvoices.length <= 0) {
              this.openInvalidModal('NO_OPEN_INVOICES_TEXT');
            }
            else if(isCurrencyMismatch){
              this.openInvalidModal('CURRENCY_MISMATCH_TEXT');
            }
            else {
              // Add res.serviceResponse.object.obppInvoices?.[0]?.invoiceNumber to this.invoiceNumber if invoice is not already present
              const newInvoiceNumber = res.serviceResponse.object.obppInvoices?.[0]?.invoiceNumber;

              if (newInvoiceNumber && !this.invoiceNumber.includes(newInvoiceNumber)) {
                this.invoiceNumber.push(newInvoiceNumber);
              }
              this.successAction.emit(res.serviceResponse);
              this.activeModal.close('OK');
            }

            this.securityAuditService(this.secAuditData);
            //Route to the new page GRID
            this.route.navigateByUrl('/quickpay');
          } else {
            this.secAuditData.status = false;
            this.securityAuditService(this.secAuditData);
            this.openModal(tit, errMsg, null, 'OK', 'warning');
          }
        },
        error: (e) => {
          this.dataSharingService.IsLoadingEnabled.next(false);
        },
      });
  }

  openInvalidModal(errorMsg:string): void {
    const title = 'QUICK_PAY_TEXT';
    this.openModal(
      title,
      errorMsg,
      null,
      'OK',
      'warning'
    );
  }

  securityAuditService(data: any) {
    this.obppQuickPayService.getQuickPaySecurityAudit(data).subscribe({
      next: (res) => {
      },
    });
  }

  openModal(
    title: string,
    errorMsg: string,
    firstButtonLabel: any,
    secondButtonLabel: any,
    modalType: string
  ) {
    const modalRef = this.modalService.open(OBPPModalDialogComponent);
    modalRef.componentInstance.my_modal_title = title;
    modalRef.componentInstance.my_modal_content = errorMsg;
    modalRef.componentInstance.firstButtonLabel = firstButtonLabel;
    modalRef.componentInstance.secondButtonLabel = secondButtonLabel;
    modalRef.componentInstance.modalType = modalType;
  }

  onAddInvoice(): void {
    this.QuickPayInvoiceForm.markAllAsTouched();
    if (this.isDuplicatePay || this.QuickPayInvoiceForm.invalid) return;
    const accountNumber = this.QuickPayInvoiceForm.get('accountNumber')?.value?.trim();
    const invoiceNumber = this.QuickPayInvoiceForm.get('invoiceNumber')?.value?.replace(/ /g, '')?.trim();
    const postalCode    = this.QuickPayInvoiceForm.get('postalCode')?.value?.replace(/ /g, '')?.trim();
    this.getQuickPayData(accountNumber, invoiceNumber, postalCode);
  }
}
